import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SubscriptionService } from 'src/app/service/subscription.service';
import { AgencyService } from 'src/app/service/agency.service';
import * as xml2js from 'xml2js';
import { AuthserviceService } from 'src/app/service/authservice.service';

@Component({
  selector: 'app-splash',
  templateUrl: './splash.component.html',
  styleUrls: ['./splash.component.css'],
})
export class SplashComponent implements OnInit {
  msisdn: string;
  source: any;
  clickId: any;
  pubId: any;
  wifiModalBox: boolean = false;
  strResponse: any;
  xml: string;
  constructor(
    private authserviceService: AuthserviceService,
    private subscriptionService: SubscriptionService,
    private agencyService: AgencyService,
    private _router: Router
  ) {}

  async ngOnInit() {
    await this.agencyService.setAgencyParameters();
    await this.fetchMSISDN();
    await this.subscriptionService.checkSubscription();
    this.source = sessionStorage.getItem('source');
    this.clickId = sessionStorage.getItem('clickId');
    this.pubId = sessionStorage.getItem('pubId');
    await this.googleUser();
  }
  async fetchMSISDN() {
    let msisdn;
    this.authserviceService
      .fetchMobileNumber()
      .then((response) => {
        //  console.log('success response ======================', response);

        const parser = new xml2js.Parser({ strict: false, trim: true });
        // console.log('XML =======================', this.strResponse);
        parser.parseString(response, (err, result) => {
          this.xml = result;
          if (
            this.xml['SOAP-ENV:ENVELOPE']['SOAP-ENV:BODY'][0][
              'NS0:SERVICERESPONSE'
            ][0]['NS0:RESPONSEHEADER'][0]['NS0:RESPONSECODE'][0] == 0
          ) {
            msisdn =
              this.xml['SOAP-ENV:ENVELOPE']['SOAP-ENV:BODY'][0][
                'NS0:SERVICERESPONSE'
              ][0]['NS0:BODY'][0]['NS1:MSISDNRESPONSE'][0]['NS1:MSISDNHASH'][0];

            localStorage.setItem('msisdn', msisdn);
            // this.subscriptionService.checkSubscription();
            this._router.navigate(['/lp']);
          } else {
            let source = sessionStorage.getItem('source');
            console.log('source...............', source);

            if (source == 'SIGADS') {
              //   sessionStorage.setItem('isSubscribed', '1');
              // msisdn = localStorage.setItem('msisdn', '191564389595');
              this._router.navigate(['/lp']);
            } else {
              console.log('NO MSISDN');
              // msisdn = localStorage.setItem('msisdn', '97028504575');
              //  msisdn = localStorage.setItem('msisdn', '191564389595');
              //   localStorage.setItem('gamezklub-mobile', '123456789');
              if (msisdn == null || msisdn == undefined || msisdn == 'NA') {
                setTimeout(() => {
                  this.wifiModal();
                }, 4000);
              }
            }
          }
        });
      })
      .catch((error) => {
        this.strResponse = error;
        // msisdn = localStorage.setItem('msisdn', '191564389595');
        // localStorage.setItem('gamezklub-mobile', '123456789');
        this._router.navigate(['/lp']);
      });
  }

  async googleUser() {
    let source = sessionStorage.getItem('source');
    console.log('source...............', source);

    if (source == 'SIGADS') {
      this._router.navigate(['/lp']);
    }
  }

  wifiModal() {
    this.wifiModalBox = true;
  }

  closeModal() {
    console.log('click');
    this.wifiModalBox = false;
  }
}
